"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileUpload = void 0;
const react_1 = require("react");
const app_1 = require("@koopajs/app");
const axios_1 = __importDefault(require("axios"));
const useFileUpload = () => {
    const [progress, setProgress] = react_1.useState(0);
    const [state, setState] = react_1.useState('ready');
    const [error, setError] = react_1.useState();
    const upload = async (file) => {
        const contentType = file.type;
        setState('uploading');
        // Get a signed URL from the API
        const { data: { signedUrl, remotePath } } = await app_1.Api.client.post('/uploads', {
            item: {
                contentType,
                distribution: 'cdn'
            }
        });
        await axios_1.default
            .put(signedUrl, file, {
            headers: {
                'Content-Type': contentType
            },
            onUploadProgress: (event) => {
                const percentageCompleted = Math.round(event.loaded / event.total);
                setProgress(percentageCompleted);
            }
        })
            .catch((e) => {
            setState('ready');
            setError(e);
            throw e;
        });
        setState('completed');
        return remotePath;
    };
    return { progress, state, error, upload };
};
exports.useFileUpload = useFileUpload;
//# sourceMappingURL=useFileUpload.js.map